import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/anbieter/:slug',
      name: 'vendor',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Vendor.vue')
    },
    {
      path: '/angebot/:slug',
      name: 'offer',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Offer.vue')
    },
    {
      path: '/collection/:slug',
      name: 'collection',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Collection.vue')
    },
    {
      path: '/',
      redirect: () => {
        window.location.href = window.firebase.remoteConfig().getValue(`${process.env.VUE_APP_ENVIRONMENT}_landingpage_url`)._value
        return '/' // not important since redirecting
      }
    },
    {
      path: '*',
      redirect: () => {
        window.location.href = window.firebase.remoteConfig().getValue(`${process.env.VUE_APP_ENVIRONMENT}_landingpage_url`)._value
        return '/' // not important since redirecting
      }
    },
  ]
})
